// Re-export corebyscott's Dropdown composition. Core's Dropdown is a drop-in for
// the reactstrap UncontrolledDropdown/Dropdown these used to wrap, and it manages
// its own reveal — so the old React-18 transition.timeout shim is gone. (#635)
import { UncontrolledDropdown, Dropdown } from '@byscott-io/corebyscott'

export const UncontrolledDropdownWrapper = UncontrolledDropdown
export const DropdownWrapper = Dropdown

// Default export stays the uncontrolled version for backward compatibility.
export default UncontrolledDropdown
